import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'vc-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent {
  @Input()
  acceptableExtensions: String[] = [];
  @Input()
  maxSize = 100;
  @Output()
  onFileSelected: EventEmitter<File[]> = new EventEmitter();

  public files: File[] = [];

  constructor() {}

  addFile(event) {
    const file = event.target.files[0];

    if (file) {
      if (this.fileIsValid(file)) {
        this.files.push(file);
        this.onFileSelected.emit(this.files);
      }
    }
  }

  removeFile(i) {
    if (this.files[i]) {
      this.files.splice(i, 1);
      this.onFileSelected.emit(this.files);
    }
  }

  fileIsValid(file: File) {
    // extension validation
    if (this.acceptableExtensions) {
      if (this.acceptableExtensions.indexOf(this.getFileExtension(file)) === -1) {
        return false;
      }
    }

    // size validation
    if (this.maxSize) {
      if (file.size > this.maxSize * 1024 * 1024) {
        return false;
      }
    }

    return true;
  }

  getFileExtension(file: File) {
    return (
      '.' +
      file.name
        .split('.')
        .reverse()[0]
        .toLowerCase()
    );
  }
}
